import { Grid, Box, styled } from "@mui/material"

export const Container = styled(Grid)(() => ({}))

export const Headline = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "21px",
}))
